<template>
  <div class="home">
    <div class="container-fluid p-0">
     <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="fotografie">
        <div class="my-auto">
          <h2 class="mb-5">Webentwicklung</h2>
          <ul class="fa-ul mb-0">
            <li>Responsive Webentwicklung</li>
            <li>continuous integration</li>
            <li>continuous deployment</li>
            <li>End-to-End Testing</li>
            <li>Monitoring</li>
            <li>Api-Entwicklung</li>
          </ul>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="fotografie">
        <div class="my-auto">
          <h2 class="mb-5">Analytics & Machine Learning</h2>
          <ul class="fa-ul mb-0">
            <li>Datenanalyse</li>
            <li>SEO</li>
            <li>Machine Learning</li>
          </ul>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="fotografie">
        <div class="my-auto">
          <h2 class="mb-5">Bild & Videobearbeitung</h2>
          <ul class="fa-ul mb-0">
            <li>Bildbearbeitung</li>
            <li>Videoproduktion</li>
            <li>Videoschnitt</li>
            <li>Animation</li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dienstleistungen',
  components: {
  }
}
</script>
